RivalIQ.module('models', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Company = data.CompanyLegacy = function () {
        this.companies = null;
        this.companiesStats = null;
    };

    Company.prototype.getLandscapeCompanyData = function (attrs) {
        const data = _.extend(attrs, {
            timePeriod: App.utils.timePeriod.serializeForAjax(attrs.timePeriod)
        });
        return $.getJSON(`/api/landscape/${attrs.landscapeId}/channels`, data);
    };

    Company.prototype.getCompanyDataByCompanyId = function (options) {
        const me = this;

        let channel;
        const presenceId = _.get(options, 'presenceId');
        if (_.isFinite(presenceId)) {
            if (RivalIQ.enums.sourceDetails[options.sources]) {
                channel = RivalIQ.enums.sourceDetails[options.sources].channel;
            }
        }

        const url = _.compact(_.flattenDeep([
            '/api/landscapes',
            options.landscapeId,
            'company',
            options.companyId,
            (channel ? _.compact(['channels', channel, options.presenceId]) : null)
        ])).join('/');

        const params = _.defaults({
            landscapeId: RivalIQ.state.view.get('landscapeId'),
            timePeriod: App.utils.timePeriod.serializeForAjax(options.timePeriod)
        }, _.omit(options, 'companyId', 'presenceId'));

        const ajaxOptions = {
            url: url,
            type: 'get',
            dataType: 'json',
            data: params
        };

        return $.ajax(ajaxOptions).then(function (data) {
            me.company = (_.isArray(data) ? _.head(data) : data);
            me.companies = {};
            me.companies[me.company.id] = me.company;
            me.compareData = new App.data.CompareData();
            me.compareData.processTrendData(me.company);

            const urlExtractedDataTrends = _.get(data, 'periodSummary.urlExtractedDataTrends');
            me.urls = me.snapshots = _.reduce(urlExtractedDataTrends, function (memo, item) {
                const id = _.get(item, 'presence.id');
                if (id) {
                    memo[id] = item;
                }
                return memo;
            }, {});

            return [me.company];
        });
    };

    Company.prototype.addUrlToCompany = function (companyId, url, callback) {
        const promise = $.post(`/api/company/${companyId}/urls`, {
            url: url
        });

        if (typeof callback === 'function') {
            promise.done(function (result) {
                callback(null, result);
            }).fail(function (xhr, status, error) {
                callback(error);
            });
        }

        return promise;
    };

});
